import { useOrganization } from 'contexts/OrganizationsContext';
import React from 'react';
import { connect } from 'react-redux';
import { AppState } from 'reducers/reducers';

export const Roles = {
    Admin: 'Admin',
    Employee: 'Employee',
    Enforcer: 'Enforcer',
    Superuser: 'Superuser',
};

type AllowedRole = (typeof Roles)[keyof typeof Roles];
type AllowedFunction = (...args: unknown[]) => AllowedRole | AllowedRole[];
type OwnProps = {
    allowed: AllowedRole | AllowedRole[] | AllowedFunction;
    children: React.ReactNode;
    /** Rendered in place of children when the role is not allowed. Nothing renders while the profile loads. */
    fallback?: React.ReactNode;
};
type ConditionalViewProps = ReturnType<typeof mapStateToProps> & OwnProps;

function ConditionalView({ allowed, children, fallback = null, profile }: ConditionalViewProps): JSX.Element {
    const { organization } = useOrganization();
    if (profile === null) return <></>;

    if (typeof allowed === 'function') {
        allowed = allowed();
    } else {
        allowed = Array.isArray(allowed) ? allowed : [allowed];
    }

    const role = organization?.role;
    if ((role && allowed.includes(role)) || profile.superuser) {
        return <>{children}</>;
    }
    return <>{fallback}</>;
}

function mapStateToProps(state: AppState) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        profile: state.auth.profile!,
    };
}

export const AuthorizedView = connect(mapStateToProps, {})(ConditionalView);
